import { render } from "./RegistrationModal.vue?vue&type=template&id=6fdd596b&ts=true&lang=pug"
import script from "./RegistrationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationModal.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationModal.vue?vue&type=style&index=0&id=6fdd596b&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__